import { companySplashType } from "../data-types/company";

export const splashInitial: companySplashType = {
    code: "",
    color: "",
    company_profile: null,
    company_profile_url: "",
    email: "",
    file_id: "",
    id: "",
    image_url: "",
    name: "",
    phone_number: "",
    website: null
}